/**
 * 応募ステータスの扱い。
 *
 * `JobApplication.status` の正準値は submitted / under_review / accepted /
 * rejected / cancelled / no_show の6種類。
 *
 * バックエンドの `user_has_applied` は「再応募できない」ことを表す旗で、
 * 応募APIの重複チェック（shift_id + store_user_id のみ・status 無条件で 409）と
 * 同じ条件になっている。したがって不採用・キャンセル済み・無断欠勤も true になる。
 *
 * 一方「出勤予定」「出勤する/退勤する」「勤務完了」「予測報酬」などは
 * **進行中の応募**にだけ出したい表示なので、status で出し分ける必要がある。
 * 両者を混同すると、不採用の求人に出勤ボタンが出る／一覧で「出勤予定」に
 * 並ぶといった不整合になる。
 */
export const ACTIVE_APPLICATION_STATUSES = ['submitted', 'under_review', 'accepted'];

/**
 * 進行中（これから勤務しうる）応募かどうか。
 *
 * status が取れないとき（BEが未対応 / 応募直後でまだ再取得していない）は
 * `fallback` を返す。応募直後は必ず進行中なので、呼び出し側は
 * 「応募済みフラグ」を fallback に渡すのが安全。
 */
export const isActiveApplicationStatus = (
  status: string | null | undefined,
  fallback = false
): boolean => (status ? ACTIVE_APPLICATION_STATUSES.includes(status) : fallback);

/**
 * 応募ボタンに出す文言。
 *
 * いずれの場合もボタンは無効化する（応募APIは status を問わず 409 を返すため、
 * 押せるようにすると必ず失敗する）。ただし「応募済み」としか出さないと、
 * 不採用のクルーが「応募済みなのに出勤ボタンが無い」画面を見ることになり
 * 理由が分からない。状態が分かる文言に出し分ける。
 */
export const applicationStatusLabel = (status: string | null | undefined): string => {
  switch (status) {
    case 'rejected':
      return '不採用';
    case 'cancelled':
      return 'キャンセル済み';
    case 'no_show':
      return '欠勤';
    default:
      // submitted / under_review / accepted / 状態不明はすべて従来どおり
      return '応募済み';
  }
};
